import Image from "next/image";

export default function OurWhy() {
  return (
    <div className="overflow-hidden bg-white py-16">
      <div className="mx-auto max-w-7xl px-6 lg:flex lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-12 gap-y-16 lg:mx-0 lg:min-w-full lg:max-w-none lg:flex-none lg:gap-y-8">
          <div className="lg:col-end-1 lg:w-full lg:max-w-lg lg:pb-8">
             <h2 className="text-3xl tracking-wide text-gray-900 sm:text-4xl">
                <span className="font-semibold text-pinto">Our Mission:</span> Help 10,000 businesses, world-wide, become and stay profitable by 2030
              </h2>
              <div className="mt-6 space-y-6 text-gray-500">
                <p className="text-lg">
                  We envision a world where business owners are financially empowered to make confident decisions, build profitable businesses and never again stress about a bill.
                </p>
                <p className="text-base leading-7">
                  We obsess over financial details so you don&apos;t have too. We love saving money and we love saving <span className="underline italic">you</span> money. 
                </p>
                <p className="text-base leading-7">
                  Our goal is to share the framework we&apos;ve built at Pinto with the world, to help everyone build a profitable and successful business.
                </p>
                <p className="text-base leading-7 font-semibold">
                  — Ben, Pinto&apos;s Financial Architect & Founder
                </p>
              </div>
          </div>
          <div className="flex flex-wrap items-start justify-end gap-6 sm:gap-8 lg:contents">
            <div className="w-0 flex-auto lg:ml-auto lg:w-auto lg:flex-none lg:self-end">
              <Image
                width={500}
                height={500}
                src="https://images.unsplash.com/photo-1670272502246-768d249768ca?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1152&q=80"
                alt=""
                className="grayscale aspect-[7/5] w-[37rem] max-w-none rounded-2xl bg-gray-50 object-cover"
                unoptimized
              />
            </div>
            <div className="contents lg:col-span-2 lg:col-end-2 lg:ml-auto lg:flex lg:w-[37rem] lg:items-start lg:justify-end lg:gap-x-8">
              <div className="order-first flex w-64 flex-none justify-end self-end lg:w-auto">
                <Image
                  width={500}
                  height={500}
                  src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
                  alt=""
                  className="grayscale aspect-[4/3] w-[24rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover"
                  unoptimized
                />
              </div>
              <div className="flex w-96 flex-auto justify-end lg:w-auto lg:flex-none">
                <Image
                  width={500}
                  height={500}
                  src="https://images.unsplash.com/photo-1568992687947-868a62a9f521?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1152&h=842&q=80"
                  alt=""
                  className="grayscale aspect-[7/5] w-[37rem] max-w-none flex-none rounded-2xl bg-gray-50 object-cover"
                  unoptimized
                />
              </div>
              <div className="hidden sm:block sm:w-0 sm:flex-auto lg:w-auto lg:flex-none">
                <Image
                  width={500}
                  height={500}
                  src="https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=842&q=80"
                  alt=""
                  className="grayscale aspect-[4/3] w-[24rem] max-w-none rounded-2xl bg-gray-50 object-cover"
                  unoptimized
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
